import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import { Highlighter } from '../../Highlighter';
import { ISuggestionGroup } from './Suggest';
import { Icon, TIconType } from '../../Icon';

import * as styles from './index.css';

export interface ICategoryProps {
  label: string;
  suggests: Array<ISuggestionGroup>;
  highlight: string;
  selected?: string;
  icon?: TIconType;

  onSelect(s: ISuggestionGroup): void;

  onHover(s: ISuggestionGroup, index: number): void;
}

export function Category({onSelect, selected, suggests, onHover, label, highlight, icon}: ICategoryProps) {
  const renderLink = (suggest: ISuggestionGroup) => {
    return suggest.url && (
      <a
        className={styles['category_block-item_link']}
        href={suggest.url}
        target="_blank"
        data-mark="CategoryLink"
      />
    );
  };

  return (
    <div data-mark="Category" className={styles['category_block']}>
      <div className={styles['category_label']}>
        <span className={styles['category_label_icon']}>
          <Icon type={icon || 'location'} size={16} color="gray_2"/>
        </span>
        {label}
      </div>
      <div>
        {suggests.map((suggest, index) => {

            return (
              <div
                key={suggest.value + index}
                className={styles['category_block-item']}
              >
                {
                  suggest.type === 'underground' &&
                  suggest.undergroundLines && (
                    <div className={styles['undergrounds']}>
                      {suggest.undergroundLines.map(line => {
                        return (
                          <div className={styles['undergrounds__item']} style={{backgroundColor: `#${line.lineColor}`}}>
                          </div>
                        );
                      })}
                    </div>
                  )
                }
                <Highlighter
                  onlyFirstInstance
                  onClick={() => onSelect(suggest)}
                  onMouseEnter={() => onHover(suggest, index)}
                  value={suggest.title}
                  term={highlight}
                  description={suggest.type === 'newobject' ? suggest.fullAddress : undefined}
                  {...mergeStyles(styles['category_variant'], selected === suggest.value && styles['hover'])}
                />
                {renderLink(suggest)}
              </div>
            );
          },
        )}
      </div>
    </div>
  );
}
